export { NAMESPACE } from '~/config/app.constants';

export const LOGGER_NAME = 'shell-component-renderer';
